export default __webpack_public_path__ + "static/breathing-920d769c945458eafc5d9fcdb002b8c9.png";